import React, { useState } from 'react';
import { MdNotifications } from 'react-icons/md';
import NotificationDropdown from './NotificationDropdown';

const NotificationBell = ({
  notificationCount = 0,
  messageCount = 0,
  supportTicketCount = 0,
  onClick,
  onOpenChat,
  onOpenSupport,
  onRefresh,
  size = 24,
  color = '#666',
  badgeColor = '#f44336',
  style = {},
  className = '',
  disabled = false,
  loading = false
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const hasNotifications = notificationCount > 0;
  const displayCount = notificationCount > 99 ? '99+' : notificationCount;

  const handleBellClick = () => {
    if (onClick) {
      onClick();
    }
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleCloseDropdown = () => {
    setIsDropdownOpen(false);
  };

  return (
    <div style={{ position: 'relative', ...style }}>
      <button
        onClick={handleBellClick}
        disabled={disabled}
        className={className}
        style={{
          position: 'relative',
          background: 'none',
          border: 'none',
          cursor: disabled ? 'default' : 'pointer',
          padding: '8px',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'background-color 0.2s ease',
          opacity: disabled ? 0.5 : 1
        }}
        onMouseEnter={(e) => {
          if (!disabled) {
            e.currentTarget.style.backgroundColor = '#f8f9fa';
          }
        }}
        onMouseLeave={(e) => {
          if (!disabled) {
            e.currentTarget.style.backgroundColor = 'transparent';
          }
        }}
        title={`${notificationCount} notification${notificationCount !== 1 ? 's' : ''}`}
        aria-label={`Notifications: ${notificationCount} unread`}
      >
      {/* Bell Icon */}
      <MdNotifications 
        size={size} 
        style={{ 
          color: hasNotifications ? '#1976d2' : color,
          transition: 'color 0.2s ease'
        }} 
      />
      
      {/* Notification Badge */}
      {hasNotifications && (
        <div
          style={{
            position: 'absolute',
            top: '2px',
            right: '2px',
            backgroundColor: badgeColor,
            color: 'white',
            borderRadius: '10px',
            minWidth: '18px',
            height: '18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '11px',
            fontWeight: 'bold',
            lineHeight: 1,
            padding: '0 4px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
            border: '2px solid white',
            animation: notificationCount > 0 ? 'pulse 2s infinite' : 'none'
          }}
        >
          {displayCount}
        </div>
      )}

      {/* CSS Animation for pulse effect */}
      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }
      `}</style>
      </button>

      {/* Notification Dropdown */}
      <NotificationDropdown
        isOpen={isDropdownOpen}
        onClose={handleCloseDropdown}
        messageCount={messageCount}
        supportTicketCount={supportTicketCount}
        onOpenChat={onOpenChat}
        onOpenSupport={onOpenSupport}
        onRefresh={onRefresh}
        loading={loading}
      />
    </div>
  );
};

export default NotificationBell;
